import { ref, type Ref } from 'vue';
import { computed } from 'vue';
import { smartTruncateHtml } from '@vp/common/util';

export type TruncateTextOptions = {
  limit: number;
  startTruncated?: boolean;
  sanitizer?: (input: string, truncate: boolean) => string;
};

type TruncateTextResult = {
  text: Ref<string>;
  truncate: Ref<boolean>;
  canTruncate: Ref<boolean>;
};

export const useTruncatedHtml = (input: Ref<string>, options: TruncateTextOptions): TruncateTextResult => {
  const { limit, startTruncated, sanitizer } = options;

  const truncate = ref<boolean>(startTruncated || false);

  const textFull = computed(() => {
    if (!sanitizer) {
      return input.value;
    }

    return sanitizer(input.value, false);
  });

  const textShort = computed(() => {
    return smartTruncateHtml(sanitizer ? sanitizer(input.value, true) : input.value, limit);
  });

  const canTruncate = computed(() => textFull.value.length !== textShort.value.length);

  const text = computed(() => (truncate.value ? textShort.value : textFull.value));

  return {
    text,
    truncate,
    canTruncate,
  };
};
